import { render, staticRenderFns } from "./CarrierQuestionsMappingModal.vue?vue&type=template&id=380d2c92&scoped=true&"
import script from "./CarrierQuestionsMappingModal.vue?vue&type=script&lang=js&"
export * from "./CarrierQuestionsMappingModal.vue?vue&type=script&lang=js&"
import style0 from "./CarrierQuestionsMappingModal.vue?vue&type=style&index=0&id=380d2c92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d2c92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380d2c92')) {
      api.createRecord('380d2c92', component.options)
    } else {
      api.reload('380d2c92', component.options)
    }
    module.hot.accept("./CarrierQuestionsMappingModal.vue?vue&type=template&id=380d2c92&scoped=true&", function () {
      api.rerender('380d2c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/CarrierQuestionsMappingModal.vue"
export default component.exports